namespace Umbrella.MailProcessing {
    export interface MailProcessingPreviewModalScope extends IPopupScope {
        mail: MailModel;
    }

    @Controller('MailProcessing', 'MailProcessingPreviewModalController')
    export class MailProcessingPreviewModalController {}
}
